import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { RequireEntitlements } from '@/components/Auth/RequireEntitlements';
import { AgentCoreSettings } from '@/components/Settings/AgentCore/AgentCoreSettings';
import { SettingsPageLayout } from '@/components/Settings/SettingsPageLayout';
import { useUser } from '@/hooks/useUser';

export const Route = createFileRoute('/$organizationName/settings/integrations/agent-connections')({
  component: SecuredAgentConnectionsPage,
});

function SecuredAgentConnectionsPage() {
  return (
    <RequireEntitlements admins={['isSuperAdmin']}>
      <AgentConnectionsPage />
    </RequireEntitlements>
  );
}

function AgentConnectionsPage() {
  const { organizationDisplayName } = useUser();

  useEffect(() => {
    document.title = `${organizationDisplayName || 'Driver'} - Agent connections`;
  }, [organizationDisplayName]);

  return (
    <SettingsPageLayout
      title="Agent connections"
      subTitle="Manage MCP servers and credentials for deployed agents."
      innerClassName="max-w-5xl"
    >
      <AgentCoreSettings />
    </SettingsPageLayout>
  );
}
